import axios from '@/axios'

class SubjectOfBusinessCategoryDataService {
  getAllCategories() {
    return axios.get('/subjectOfBusiness/getAllSubjectsOfBusinessCategories')
  }
  add(data) {
    return axios.post('/subjectOfBusiness/category/add', data)
  }
  update(id, data) {
    return axios.put(`/subjectOfBusiness/category/${id}/update`, data)
  }
  delete(id) {
    return axios.delete(`/subjectOfBusiness/category/${id}/delete`)
  }
}

export default new SubjectOfBusinessCategoryDataService()
